"use strict";
exports.__esModule = true;
exports.useRef = exports.useEffect = exports.useState = exports.useTransactionState = exports.useDocumentState = exports.useDeferredNode = exports.setCurrentHooks = void 0;
var currentHooks = null;
exports.setCurrentHooks = function (hooks) {
    currentHooks = hooks;
};
exports.useDeferredNode = function (nodeIds, callback) {
    return currentHooks.useDeferredNode(nodeIds, callback);
};
exports.useDocumentState = function (path, initialState) {
    return currentHooks.useDocumentState(path, initialState);
};
exports.useTransactionState = function (path, initialState) {
    return currentHooks.useTransactionState(path, initialState);
};
exports.useState = function (initialValue) { return currentHooks.useState(initialValue); };
exports.useEffect = function (fn, dependencies) { return currentHooks.useEffect(fn, dependencies); };
exports.useRef = function (initialValue) { return currentHooks.useRef(initialValue); };
